import "./Tooltip.scss";

export type TooltipPositions =
  | "top"
  | "bottom"
  | "left"
  | "right"
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right";

export type Variant = "primary" | "info" | "warning" | "error" | "clear";

export interface TooltipProps {
  children: React.ReactNode;
  tail?: boolean;
  variant?: Variant;
  shadow?: boolean;
  position?: TooltipPositions;
  visible?: boolean;
  width?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  tail = false,
  variant = "primary",
  shadow = false,
  position = "top",
  visible = false,
  width,
  className = "",
  style = {},
}) => {
  const classes = [
    "tooltip",
    visible ? "is-visible" : "",
    width && width > 0 ? "custom-width" : "",
    `tooltip-variant-${variant}`,
    `tooltip-position-${position}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const tooltipStyle = {
    ...style,
    width: width ? `${width}px` : "auto",
  };

  return (
    <div className={classes} style={tooltipStyle}>
      {children}
      {tail && <div className="tooltip-tail" />}
    </div>
  );
};
